export enum StatusDataBase {
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  EM_BANCO = 'EM_BANCO',
  UPDATE = 'UPDATE',
  CAD = 'CAD'
}
